import './breadcrumbs.scss';

import FeatherIcon from 'feather-icons-react';
import React from 'react';
import { Link } from 'react-router-dom';

type BreadcrumbItem = {
  name: string;
  isActive?: boolean;
  path?: string;
};

type BreadcrumbsProps = {
  breadcrumbs: BreadcrumbItem[];
};

export const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ breadcrumbs: items }) => {
  const breadcrumbs: BreadcrumbItem[] = [{ name: 'Home', isActive: false, path: '/' }, ...items];

  return (
    <nav className="page-breadcrumbs pt-md-2 pt-lg-3 pb-4 pb-md-5 mb-xl-4" aria-label="breadcrumb">
      <ol className="breadcrumb mb-0">
        {breadcrumbs.map((breadcrumb, index) => (
          <li key={breadcrumb.path ?? breadcrumb.name} className={'breadcrumb-item' + (breadcrumb.isActive ? ' active' : '')}>
            {index !== 0 ? <FeatherIcon icon="chevrons-right" size="16" className="fs-lg me-1" /> : null}
            {breadcrumb.isActive || !breadcrumb.path ? (
              breadcrumb.name
            ) : (
              <Link to={breadcrumb.path}>{breadcrumb.name}</Link>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
};
